export default {
  index: {
    search: {
      title: 'Price Guide',
      subtitle: 'Discover and compare gear value',
      placeholder: 'Search by brand and model',
      marketplaceLinkText: 'Search Marketplace',
    },
    instructions: {
      title: 'How it works',
      step1: '1) Search for gear',
      step2: '2) Enter gear details for accurate range',
      step3: '3) Review how much it\'s worth',
    },
    card: {
      button: 'Get Price Estimate',
      multipleFinishes: 'Multiple Finishes',
    },
    bailCard: {
      text: "Can't find what you're looking for?",
      linkText: 'Search the marketplace for live listings',
      subtext: "(Live listings aren't indicative of price recommendations)",
    },
  },
  show: {
    form: {
      gearCollectionButton: {
        ownOne: 'Own one like this?',
        addingGear: 'Adding gear to your Collection allows you to track its value over time.',
        addToCollectionButtonText: 'Add to My Collection',
        viewCollectionButtonText: 'View in My Collection',
        errors: {
          title: 'Error when adding to your Collection',
          message: 'Sorry, we were unable to add this to your Collection. Please try again or %{tagOpen}contact support%{tagClose}.',
        },
      },
      gearDetails: 'Gear Details',
      modelVersion: 'Model Version',
      condition: 'Condition',
      disclaimer: 'We only use this information temporarily to give you an accurate representation of gear value and it is not stored.',
      conditionHelpText: 'Learn more about our conditions',
      backButtonText: 'Back',
      priceGearButtonText: 'Price Gear',
      results: {
        reverbEstimatedValue: 'Reverb Estimated Value',
        basedOn: 'Based on orders for %{boldOpen}%{modelName}%{boldClose} in %{boldOpen}%{condition} Condition%{boldClose}',
        estimatedPriceRange: 'Estimated Price Range',
        condition: 'Condition',
        estimateUnavailable: 'Estimate from Reverb not available.',
        regionalEstimateCaveat: 'Note: Estimate based on US sales prices for similar items on Reverb. Non-US regional data coming soon!',
        pastThirtyDays: 'Past 30 Days',
        averageItemPriceSold: 'Average Item Price Sold',
        sellYoursButtonText: 'Sell Yours',
        viewLiveListingsText: 'View Live Listings',
        transactionGraph: {
          pastSoldListings: 'Past Sold Listings',
          pricesReflect: 'Prices reflect monthly average for sales of item in %{condition} condition. Prices exclude shipping and tax/VAT/GST.',
          tooltip: {
            productsSold: '%{totalAmount} Product(s) Sold',
            amountAverage: '%{formattedAmount} average for %{dateString}',
            basedOn: 'Based on %{numberAmount} order(s)',
            condition: 'Condition: %{conditionText}',
          },
          buttonGroup: {
            months_6: '6 months',
            years_1: '1 year',
            years_2: '2 years',
          },
        },
      },
    },
  },
};
